<template>
  <path pid="0" d="M24 13a11 11 0 10-11 11 11 11 0 0011-11zM4 13a9 9 0 119 9 9 9 0 01-9-9z"/><path pid="1" d="M18 13a1 1 0 00-1-1H9a1 1 0 000 2h8a1 1 0 001-1z"/>
</template>
